import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/components/documentation.css';

function Documentation() {
  const { t } = useTranslation();

  return (
    <div className="documentation-page">
      <h1>{t('documentation.title')}</h1>
      
      <div className="documentation-sections">
        <div className="doc-sidebar">
          <h3>{t('documentation.sections')}</h3>
          <ul>
            <li><a href="#getting-started">{t('documentation.sidebar.getting_started')}</a></li>
            <li><a href="#features">{t('documentation.sidebar.features')}</a></li>
            <li><a href="#meal-planning">{t('documentation.sidebar.meal_planning')}</a></li>
            <li><a href="#glucose-tracking">{t('documentation.sidebar.glucose_tracking')}</a></li>
            <li><a href="#reports">{t('documentation.sidebar.reports')}</a></li>
            <li><a href="#faq">{t('documentation.sidebar.faq')}</a></li>
          </ul>
        </div>
        
        <div className="doc-content">
          <section id="getting-started">
            <h2>{t('documentation.sidebar.getting_started')}</h2>
            <p>{t('documentation.getting_started.welcome')}</p>
            
            <h3>{t('documentation.getting_started.installation')}</h3>
            <p>{t('documentation.getting_started.installation_text')}</p>
            
            <h3>{t('documentation.getting_started.initial_setup')}</h3>
            <p>{t('documentation.getting_started.initial_setup_text')}</p>
          </section>
          
          <section id="features">
            <h2>{t('documentation.sidebar.features')}</h2>
            <p>{t('documentation.features.overview')}</p>
            
            <ul className="feature-list">
              <li>{t('documentation.features.real_time_glucose_tracking')}</li>
              <li>{t('documentation.features.meal_planning')}</li>
              <li>{t('documentation.features.food_database')}</li>
              <li>{t('documentation.features.medication_reminders')}</li>
              <li>{t('documentation.features.detailed_reports')}</li>
              <li>{t('documentation.features.device_sync')}</li>
              <li>{t('documentation.features.secure_sharing')}</li>
            </ul>
          </section>
          
          <section id="meal-planning">
            <h2>{t('documentation.sidebar.meal_planning')}</h2>
            <p>{t('documentation.meal_planning.overview')}</p>
            
            <h3>{t('documentation.meal_planning.main_features')}</h3>
            <ul>
              <li>{t('documentation.meal_planning.personalized_suggestions')}</li>
              <li>{t('documentation.meal_planning.automatic_carb_calculation')}</li>
              <li>{t('documentation.meal_planning.diet_alternatives')}</li>
            </ul>
          </section>

          <section id="glucose-tracking">
            <h2>{t('documentation.sidebar.glucose_tracking')}</h2>
            <p>{t('documentation.glucose_tracking.overview')}</p>
            
            <h3>{t('documentation.glucose_tracking.tracking_features')}</h3>
            <ul>
              <li>{t('documentation.glucose_tracking.easy_recording')}</li>
              <li>{t('documentation.glucose_tracking.real_time_graphs')}</li>
              <li>{t('documentation.glucose_tracking.custom_alerts')}</li>
            </ul>
          </section>

          <section id="reports">
            <h2>{t('documentation.sidebar.reports')}</h2>
            <p>{t('documentation.reports.overview')}</p>
          </section>

          <section id="faq">
            <h2>{t('documentation.sidebar.faq')}</h2>
            <h3>{t('documentation.faq.questions')}</h3>
            <div className="faq-item">
              <h4>{t('documentation.faq.sync_data')}</h4>
              <p>{t('documentation.faq.sync_data_text')}</p>
            </div>
            <div className="faq-item">
              <h4>{t('documentation.faq.offline_usage')}</h4>
              <p>{t('documentation.faq.offline_usage_text')}</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Documentation;